export default "__VITE_ASSET__gHk8FXRG__"